module.exports = __webpack_public_path__ + "assets/img/travel-day16.db566d53.png";